<template>
  <div class="login">
    <img :src="orlando" width="80px" class="mb-5">

    <el-form @keyup.enter.native.stop="login" style="width:220px">
      <el-form-item>
        <el-input v-model="email" placeholder="E-mail"></el-input>
      </el-form-item>

      <el-form-item>
        <el-input type="password" v-model="senha" placeholder="Senha"></el-input>
      </el-form-item>

      <el-button class="botao" @click="login" :loading="entrando">
        <span>Entrar</span>
      </el-button>
    </el-form>
  </div>
</template>

<script>
import Orlando from '../assets/orlando-verde.png';

export default {
  name: 'Login',
  data() {
    return {
      email: '',
      senha: '',
      entrando: false,
      orlando: Orlando
    };
  },
  methods: {
    login() {
      this.entrando = true;
      this.$auth.signInWithEmailAndPassword(this.email, this.senha).then(user => {
        if (user) {
          const uid = user.user.uid;
          const ref = this.$db.ref(`colaboradores/${uid}/isAdmin`);
          ref.on('value', snap => {
            if (snap.val()) this.$router.replace('/');
            else {
              window.alert('Usuário não é administrador.');
              this.$auth.signOut();
            }
            this.entrando = false;
          });
        }
      },
      error => {
        alert(error.message);
        this.entrando = false;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.login {
  display: flex;
  flex: 1;
  height: 100%;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
}

.botao {
  width: 100%;
}
</style>
